import { sdkRequest, translateServerErrors } from '@eventbrite/http';
import { gettext } from '@eventbrite/i18n';
import { formatUrl } from 'url-lib';

const NOT_AUTHORIZED_ERROR = gettext(
    'You do not have permission to access the resource you requested.',
);
const SUBSCRIPTION_NOT_FOUND = gettext(
    'The profile you requested does not exist.',
);
const STANDARD_SERVER_ERROR = gettext(
    'There was an issue with the server, try again',
);
const GENERAL_ERROR_SPEC = {
    NOT_AUTHORIZED: () => NOT_AUTHORIZED_ERROR,
    SUBSCRIPTION_NOT_FOUND: () => SUBSCRIPTION_NOT_FOUND,
    USER_HAS_NO_PASSWORD: () => 'USER_HAS_NO_PASSWORD',

    default: () => STANDARD_SERVER_ERROR,
};

interface ThenData {
    taxpayer_information: string;
    document_request_status: string;
}

export const fetchTaxpayerInformationSummary = (orgId: string) =>
    sdkRequest(
        formatUrl(
            `/api/v3/organizations/${orgId}/active_taxpayer_information/`,
        ),
    )
        .then(
            ({
                taxpayer_information: taxpayerInformation,
                document_request_status: documentRequestStatus,
            }: ThenData): {
                taxpayerInformation: string;
                documentRequestStatus: string;
            } => ({
                taxpayerInformation,
                documentRequestStatus,
            }),
        )
        .catch(translateServerErrors(GENERAL_ERROR_SPEC));
